import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getToken } from '../api';

export default function Welcome() {
  const navigate = useNavigate();

  useEffect(() => {
    if (getToken()) navigate('/matches');
  }, [navigate]);

  return (
    <div className="welcome-screen">
      <div>
        <div className="welcome-headline">
          <div>The Last</div>
          <div className="gold">Dating App</div>
        </div>
        <div className="welcome-tagline">No swipe. Just real matches.</div>
      </div>

      <div className="welcome-actions">
        <button className="btn btn-gold" onClick={() => navigate('/signup')}>
          Begin
        </button>
        <button className="btn btn-muted" onClick={() => navigate('/login')}>
          Sign in
        </button>
      </div>
    </div>
  );
}
